// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".analytics-tabs{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;font-size:24px;gap:14px}.analytics-tabs .tab-item{color:var(--text-disable);padding:12px 0;-webkit-transition:.2s;-o-transition:.2s;transition:.2s}.analytics-tabs .tab-item.active{color:var(--text-default)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
